export const equalMultiUnitValues = (multiChoiceMode, valueIsEqual) =>
  !multiChoiceMode || valueIsEqual === undefined || valueIsEqual
